import Vue from 'vue';

import TrioAssets from 'trio-assets-js';

// stylings
import './scss/app.scss';

// scripts
// utils
import './js/utils/copy';
import './js/utils/text-overflow';
// elements
import './js/elements/accordion';
import './js/elements/certificates';
import './js/elements/featured-product';
import './js/elements/featured-product-line';
import './js/elements/form';
import './js/elements/form-view-filters';
import './js/elements/key-facts';
import './js/elements/on-scroll';
import './js/elements/person-list';
import './js/elements/privacy-settings-link';
import './js/elements/product-categories-overview';
import './js/elements/product-inquiry';
import './js/elements/product-versions'; // also includes component init
import './js/elements/scroll-to-element';
import './js/elements/tabs';
import './js/elements/technical-information';
import './js/elements/timeline';
// navigation
import './js/navigation/inpage-navigation';
import './js/navigation/main-menu';
import './js/navigation/main-menu-mobile';
import './js/navigation/views-scroll';
// components
import ContactPersons from './js/components/ContactPersons';
import ProductsPortfolio from './js/components/ProductsPortfolio';

Vue.config.productionTip = false;

(() => {
  TrioAssets.parallax();
})();

Vue.component('contact-persons', ContactPersons);
Vue.component('products-portfolio', ProductsPortfolio);

if (document.getElementById('contact-persons')) {
  new Vue({
    el: '#contact-persons',
    comments: true,
  });
}

if (document.getElementById('products-portfolio')) {
  new Vue({
    el: '#products-portfolio',
    comments: true,
  });
}
